import { ExistingProvider } from "../types";
import type { Provider } from "../../../../DealerAcquirersTable/types";

const PRIORITY_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

export function calculateAvailablePriorities(
  externalDealerProviders?: Provider[],
  mode?: "ADD" | "EDIT",
  existingProvider?: ExistingProvider | null,
): number[] {
  const registeredPriorities = externalDealerProviders
    ? externalDealerProviders.map((provider) => Number(provider.priority))
    : [];

  let availablePriorities = PRIORITY_OPTIONS.filter(
    (priority) => !registeredPriorities.includes(priority),
  );

  if (mode === "EDIT" && existingProvider) {
    const editingPriority = Number(existingProvider.priority);
    if (!availablePriorities.includes(editingPriority)) {
      availablePriorities = [editingPriority, ...availablePriorities].sort(
        (a, b) => a - b,
      );
    }
  }

  return availablePriorities.slice(0, 5);
}
